import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { DevisStatut, IDevisResponse } from 'src/app/shared/models/devis';
import { DevisService } from '../devis.service';
import { DevisViewDialogComponent } from '../devis-view-dialog/devis-view-dialog.component';
import { DevisValidateDialogComponent } from './devis-validate-dialog/devis-validate-dialog.component';
import { DevisRefuseDialogComponent } from './devis-refuse-dialog/devis-refuse-dialog.component';
import { DevisRetourDialogComponent } from '../devis-retour-dialog/devis-retour-dialog.component';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Sort } from '@angular/material/sort';



@Component({
  selector: 'app-devis-validation',
  templateUrl: './devis-validation.component.html',
  styleUrls: ['./devis-validation.component.less']
})
export class DevisValidationComponent implements AfterViewInit {

  devisList: MatTableDataSource<IDevisResponse>;
  displayedColumns: string[] = [
    'devisReference', 'devisMontantTotal', 'devisBeneficiaire',
    'febDivisionDemandeurNom', 'febProjectNom',
    'devisDateDemarrageGo', 'devisDuree', 'actions'
  ];

  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private devisService: DevisService,
    private dialog: MatDialog,
    private snackbarService: SnackbarService,
    private _liveAnnouncer: LiveAnnouncer
  ) {
    this.devisList = new MatTableDataSource();
    this.loadDevis();
  }

  loadDevis(): void {
    this.devisService.getByStatut(DevisStatut.EN_ATTENTE).subscribe({
      next: data => { this.devisList.data = data; },
      error: () => this.snackbarService.openSnackBar('Erreur lors du chargement des devis', 'error-snack-bar')
    });
  }

  announceSortChange(sortState: Sort) {
  if (sortState.direction) {
    this._liveAnnouncer.announce(
      `Tri ${sortState.direction === 'asc' ? 'ascendant' : 'descendant'}`
    );
  } else {
    this._liveAnnouncer.announce('Tri réinitialisé');
  }
}

  ngAfterViewInit(): void {
  this.devisList.sort = this.sort;

  // Tri par défaut (ex : date démarrage desc)
  this.sort.active = 'devisDateDemarrageGo';
  this.sort.direction = 'desc';

  this.sort.sortChange.emit({
    active: this.sort.active,
    direction: this.sort.direction
  });

  // Adapter les types pour tri correct
  this.devisList.sortingDataAccessor = (item, property) => {
    switch (property) {

      case 'devisDateDemarrageGo':
        return item.devisDateDemarrageGo
          ? new Date(item.devisDateDemarrageGo).getTime()
          : 0;

      case 'devisMontantTotal':
        return item.devisMontantTotal ?? 0;

      case 'devisDuree':
        return item.devisDuree ?? 0;

      default:
        return (item as any)[property];
    }
  };
}


  applyFilter(event: Event): void {
    this.devisList.filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
  }

  openDevis(devis: IDevisResponse): void {
    this.dialog.open(DevisViewDialogComponent, {
      width: '880px',
      maxWidth: '98vw',
      maxHeight: '94vh',
      data: devis
    });
  }

  openValiderDialog(devis: IDevisResponse): void {
    const ref = this.dialog.open(DevisValidateDialogComponent, {
      width: '480px',
      maxWidth: '98vw',
      disableClose: true,
      data: devis
    });
    ref.afterClosed().subscribe(ok => { if (ok) this.loadDevis(); });
  }

  openRefuserDialog(devis: IDevisResponse): void {
    const ref = this.dialog.open(DevisRefuseDialogComponent, {
      width: '480px',
      maxWidth: '98vw',
      disableClose: true,
      data: devis
    });
    ref.afterClosed().subscribe(ok => { if (ok) this.loadDevis(); });
  }

  openRetourDialog(devis: IDevisResponse): void {
    const ref = this.dialog.open(DevisRetourDialogComponent, {
      width: '520px',
      maxWidth: '98vw',
      disableClose: true,
      data: devis
    });
    ref.afterClosed().subscribe(ok => { if (ok) this.loadDevis(); });
  }
}
